import ImageContent from "./image-content";
import Testimonials from "./testimonials";
import ReachCTA from "./reach-cta";
import ServicesShowcase from "./services-showcase";
import BooksShowcase from "./books-showcase";
import GenreCards from "./genre-cards";
import TripleColumn from "./triple-column";
import BooksMarquee from "./books-marquee";
import {
  SectionHeading,
  BackdropBlobs,
  FlourishDivider,
  AnimatedQuill,
  SealBadge,
  OpenBookLine,
  GlyphBadge,
  FloatingPages,
} from "./decor";
export {
  ImageContent,
  Testimonials,
  ReachCTA,
  ServicesShowcase,
  BooksShowcase,
  GenreCards,
  TripleColumn,
  BooksMarquee,
  SectionHeading,
  BackdropBlobs,
  FlourishDivider,
  AnimatedQuill,
  SealBadge,
  OpenBookLine,
  GlyphBadge,
  FloatingPages,
};
